export const DEFAULT_LEGISLATIVE_TYPES = [
    {
        name: 'Ordinance',
        code: 'ORD',
        description: 'Formal local law adopted by the City Commission. Requires two readings; the second reading is conducted as a public hearing.',
        status: 'active',
        orderById: 1,
        consentEligible: false,
        emergencyEligible: true,
        executiveSession: false,
        timeEstimate: true,
        noticePeriod: 10,
        publicHearing: 'required',
        legislativeActions: ['ADOPT', 'APPROVE'],
        defaultActionId: 'ADOPT',
    },
    {
        name: 'Resolution',
        code: 'RES',
        description: 'Formal expression of City Commission policy or action; adopted in a single reading.',
        status: 'active',
        orderById: 2,
        consentEligible: true,
        emergencyEligible: true,
        executiveSession: false,
        timeEstimate: true,
        noticePeriod: 0,
        publicHearing: 'optional',
        legislativeActions: ['ADOPT', 'APPROVE'],
        defaultActionId: 'ADOPT',
    },
    {
        name: 'Ceremonial',
        code: 'CEREM',
        description: 'Proclamations, recognitions, and swearing-ins. No formal Commission action required.',
        status: 'active',
        orderById: 3,
        consentEligible: true,
        emergencyEligible: false,
        executiveSession: false,
        timeEstimate: true,
        noticePeriod: 0,
        publicHearing: 'not_applicable',
        legislativeActions: ['ACCEPT'],
        defaultActionId: 'ACCEPT',
    },
    {
        name: 'Report / Presentation',
        code: 'RPT',
        description: 'Informational presentation by staff, advisory boards, or invited parties. Commission may give direction by consensus; no formal vote.',
        status: 'active',
        orderById: 4,
        consentEligible: false,
        emergencyEligible: false,
        executiveSession: false,
        timeEstimate: true,
        noticePeriod: 0,
        publicHearing: 'not_applicable',
        legislativeActions: ['RECEIVE_AND_FILE'],
        defaultActionId: 'RECEIVE_AND_FILE',
    },
    {
        name: 'Purchase / Award Authorization',
        code: 'AUTH',
        description: 'Commission authorization for the City Manager to procure goods, services, or construction, or to award a competitive solicitation.',
        status: 'active',
        orderById: 5,
        consentEligible: true,
        emergencyEligible: true,
        executiveSession: false,
        timeEstimate: true,
        noticePeriod: 0,
        publicHearing: 'not_applicable',
        legislativeActions: ['AUTHORIZE', 'APPROVE', 'AWARD'],
        defaultActionId: 'AUTHORIZE',
    },
    {
        name: 'Agreement',
        code: 'AGR',
        description: 'Approval of a contract, interlocal agreement, MOU, settlement agreement, or other binding instrument with an external party.',
        status: 'active',
        orderById: 6,
        consentEligible: true,
        emergencyEligible: true,
        executiveSession: true,
        timeEstimate: true,
        noticePeriod: 0,
        publicHearing: 'not_applicable',
        legislativeActions: ['APPROVE', 'AUTHORIZE', 'ACCEPT', 'RATIFY'],
        defaultActionId: 'APPROVE',
    },
    {
        name: 'Approval of Minutes',
        code: 'MIN',
        description: 'Approval of the minutes of a prior City Commission meeting.',
        status: 'active',
        orderById: 7,
        consentEligible: true,
        emergencyEligible: false,
        executiveSession: false,
        timeEstimate: false,
        noticePeriod: 0,
        publicHearing: 'not_applicable',
        legislativeActions: ['APPROVE'],
        defaultActionId: 'APPROVE',
    },
    {
        name: 'Board Appointment',
        code: 'APPT',
        description: 'Appointment of a member to a City advisory board, committee, or authority.',
        status: 'active',
        orderById: 8,
        consentEligible: true,
        emergencyEligible: false,
        executiveSession: false,
        timeEstimate: true,
        noticePeriod: 0,
        publicHearing: 'not_applicable',
        legislativeActions: ['CONFIRM', 'APPROVE'],
        defaultActionId: 'CONFIRM',
    },
];
